<template>
<layout-header/>
<layout-main/>
</template>
<script lang="ts" setup>
import LayoutHeader from './LayoutHeader.vue'
import LayoutMain from './LayoutMain.vue'
defineOptions({
  name: "LayoutIndex",
})
</script>
<style lang='postcss' scoped>
    
</style>
